import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const usePersistentListFilters = (defaults = {}) => {
  const history = useHistory();
  const location = useLocation();
  const query = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      search: params.get('search') || defaults.search || '',
      site: params.get('site') || defaults.site || 'all',
      date: params.get('date') || defaults.date || ''
    };
  }, [defaults.search, defaults.site, location.search]);

  const setFilters = useCallback((patch) => {
    const params = new URLSearchParams(location.search);
    const next = { ...query, ...patch };

    ['search', 'site', 'date'].forEach((key) => {
      const value = next[key];
      const defaultValue = defaults[key] || (key === 'site' ? 'all' : '');
      if (value && value !== defaultValue) params.set(key, String(value));
      else params.delete(key);
    });

    const search = params.toString();
    history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' });
  }, [defaults, history, location.pathname, location.search, query]);

  return {
    search: query.search,
    site: query.site,
    date: query.date,
    setSearch: (search) => setFilters({ search }),
    setSite: (site) => setFilters({ site }),
    setDate: (date) => setFilters({ date }),
    setFilters
  };
};

export default usePersistentListFilters;
